import type { ScheduledPremium } from "@/types/insurance";

/**
 * Assigns a status to a scheduled premium entry.
 *
 * Rules:
 * - 'paid'     — dueDate matches any recorded payment date (same calendar date)
 * - 'overdue'  — dueDate is in the past and no matching payment exists
 * - 'upcoming' — dueDate is today or in the future and no matching payment exists
 *
 * @param dueDate     ISO date string YYYY-MM-DD
 * @param paidDates   Set of recorded payment dates (ISO date strings YYYY-MM-DD)
 * @param today       Today's date with time zeroed to midnight
 */
export function assignScheduleEntryStatus(
  dueDate: string,
  paidDates: Set<string>,
  today: Date,
): ScheduledPremium["status"] {
  if (paidDates.has(dueDate)) {
    return "paid";
  }
  const due = new Date(dueDate);
  due.setHours(0, 0, 0, 0);
  return due < today ? "overdue" : "upcoming";
}
